export function handleFunction(setState, state, setDefaultValues, removeDefaultValues) {
  return () => {
    setState({
      checked: (state.checked = !state.checked),
    });
    handleDefaultFunction(state, setDefaultValues, removeDefaultValues);
  };
}

export function handleDefaultFunction(state, setDefaultValues, removeDefaultValues) {
  if (state.checked === true) {
    setDefaultValues();
  } else {
    removeDefaultValues();
  }
}

